import React, { FC } from 'react';

import styled from 'styled-components';

import aampeTheme from '../../../../../../constants/aampeTheme';

// components
import DatasetSelectDropdown from './DatasetSelectDropdown';

interface DatasetConfigurationalHeaderProps {
    isEditable: boolean;
    isContentTableComponent: boolean;
    selectedDatasetId?: number;
    setSelectedDatasetId: (id: number) => void;
    appliedDatasetFieldIds?: number[];
    showHeadingDescription?: boolean;
}

const DatasetConfigurationalHeader: FC<DatasetConfigurationalHeaderProps> = ({
    isEditable,
    isContentTableComponent,
    selectedDatasetId,
    setSelectedDatasetId,
    appliedDatasetFieldIds,
    showHeadingDescription,
}) => {
    return (
        <Header>
            <Heading>
                <Title>Configure a dataset</Title>
                {showHeadingDescription && (
                    <Description>
                        Edit filters and insert the dataset in your message
                    </Description>
                )}
            </Heading>
            {isContentTableComponent && (
                <DatasetSelectDropdown
                    isEditable={isEditable}
                    selectedDatasetId={selectedDatasetId}
                    setSelectedDatasetId={setSelectedDatasetId}
                    appliedDatasetFieldIds={appliedDatasetFieldIds}
                />
            )}
        </Header>
    );
};

export default DatasetConfigurationalHeader;

const Header = styled.div({
    display: 'flex',
    justifyContent: 'space-between',
});

const Heading = styled.div({
    display: 'flex',
    flexDirection: 'column',
    gap: aampeTheme.spacing4(2),
});

const Title = styled.div({
    display: 'flex',
    fontSize: aampeTheme.size.font.heading,
    fontWeight: aampeTheme.weights.heavy,
    lineHeight: aampeTheme.size.lineHeight.extraTall,
});

const Description = styled.div({
    display: 'flex',
});
